import { AutociteCslDataInput } from '@chegg-wt/core/globalTypesOneGraph'
import { AUTOCITE_CSL_DATA_FROM_DS } from '../oneGraphQueries/AutociteCslData'
import {
  AutociteCslData,
  AutociteCslDataVariables,
} from '../oneGraphQueries/__generated__/AutociteCslData'
import { client } from './graphApi'

export const getCslDataFromDSApi = (request: AutociteCslDataInput) => {
  return client.query<AutociteCslData, AutociteCslDataVariables>({
    query: AUTOCITE_CSL_DATA_FROM_DS,
    variables: { request },
    context: {
      clientName: 'oneGraph',
    },
  })
}
